<form [formGroup]="AnexosForm">
    <mat-card>
        <mat-card-title class="matCard-Font">Anexos da Reforma</mat-card-title>

        <!-- Nome -->
        <div class="row">
            <div class="col-sm-10 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Nome</mat-label>
                    <input formControlName="Nome" matInput type="text" maxlength="200">
                    <button mat-button mat-icon-button matSuffix aria-label="Clear" (click)="pesquisarAnexo()">
                        <mat-icon>search</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <div class="col-sm-2 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>CST</mat-label>
                    <input formControlName="Cst" matInput type="text">
                </mat-form-field>
            </div>
        </div>

        <!-- NCM / CST -->
        <div class="row">

        </div>

        <!-- Classificações Tributárias -->
        <div class="row">
            <div class="col-sm-6 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Classificação Tributária (cClassTrib)</mat-label>
                    <input formControlName="cClassTrib" matInput type="text">
                </mat-form-field>
            </div>

            <div class="col-sm-6 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Classificação Tributária IS (cClassTribIs)</mat-label>
                    <input formControlName="cClassTribIs" matInput type="text">
                </mat-form-field>
            </div>
        </div>

        <!-- Aliquotas e Reduções IBS -->
        <div class="row">
            <div class="col-sm-3 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Alíquota IBS</mat-label>
                    <input formControlName="AliquotaIbs" matInput type="number" step="0.01">
                </mat-form-field>
            </div>

            <div class="col-sm-3 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Redução IBS</mat-label>
                    <input formControlName="ReducaoIbs" matInput type="number" step="0.01">
                </mat-form-field>
            </div>

            <div class="col-sm-3 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Alíquota IBS Municipal</mat-label>
                    <input formControlName="AliquotaIbsMunicipal" matInput type="number" step="0.01">
                </mat-form-field>
            </div>

            <div class="col-sm-3 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Redução IBS Municipal</mat-label>
                    <input formControlName="ReducaoIbsMunicipal" matInput type="number" step="0.01">
                </mat-form-field>
            </div>
        </div>

        <!-- Aliquotas e Reduções CBS -->
        <div class="row">
            <div class="col-sm-6 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Alíquota CBS</mat-label>
                    <input formControlName="AliquotaCbs" matInput type="number" step="0.01">
                </mat-form-field>
            </div>

            <div class="col-sm-6 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Redução CBS</mat-label>
                    <input formControlName="ReducaoCbs" matInput type="number" step="0.01">
                </mat-form-field>
            </div>
        </div>

        <!-- CST IS + Aliquota IS -->
        <div class="row">
            <div class="col-sm-6 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>CST IS</mat-label>
                    <input formControlName="CstIs" matInput type="text">
                </mat-form-field>
            </div>

            <div class="col-sm-6 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Alíquota IS</mat-label>
                    <input formControlName="AliquotaIs" matInput type="number" step="0.01">
                </mat-form-field>
            </div>
        </div>

        <!-- Vigências -->
        <div class="row">
            <div class="col-sm-6 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Vigência Início</mat-label>
                    <input formControlName="VigenciaInicio" matInput type="date">
                </mat-form-field>
            </div>

            <div class="col-sm-6 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Vigência Fim</mat-label>
                    <input formControlName="VigenciaFim" matInput type="date">
                </mat-form-field>
            </div>
        </div>

        <!-- Descrição -->
        <div class="row">
            <div class="col-sm-12 col-12">
                <mat-form-field class="formField-Font" appearance="fill" style="width: 100%;">
                    <mat-label>Descrição</mat-label>
                    <textarea formControlName="Descricao" matInput rows="3"></textarea>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-sm-12">
                <app-tabela-categorias [categorias]="ListaCategorias" [anexo]="AnexosForm.value" (getAnexo)="get($event)" (excluirCategoriaOut)="postCategoria($event)"></app-tabela-categorias>
            </div>
        </div>
    </mat-card>

    <app-crud-buttons [showPost]="AnexosForm.value.Id == 0" [showPut]="AnexosForm.value.Id != 0" [showDelete]
        [labelBotaoPost]="'Gravar'" [labelBotaoPut]="'Gravar'" [labelBotaoAuxUm]="'Limpar formulário'"
        [disablePost]="AnexosForm.status == 'INVALID'" [disablePut]="AnexosForm.status == 'INVALID'"
        [disableDelete]="AnexosForm.value.Id == 0" (OnClickButtonPost)="post()" (OnClickButtonPut)="put()"
        (OnClickButtonAuxUm)="limpar()" (OnClickButtonDelete)="delete()">
    </app-crud-buttons>
</form>